import { BASE_URL } from "../configs";
import { getAccessToken } from "../helpers/auth/token";
import { getQueryParamsString } from "../lib/utils";
import axiosInstance from "./axios";

export async function getClient(clientId) {
  let url = `${BASE_URL}/api/client/${clientId}`;

  const res = await axiosInstance.get(url)
  return res.data.Data;
}


export async function getClients({ q, page, perPage }) {
  let url = `${BASE_URL}/api/client?`;
  url += getQueryParamsString({ q, page, perPage });

  const res = await axiosInstance.get(url)
  return res.data.Data;
}


export async function createClient(client) {
  let url = `${BASE_URL}/api/client`;

  const res = await axiosInstance.post(url, JSON.stringify(client))
  return res.data.Data;
}

export async function updateClient(client) {
  let url = `${BASE_URL}/api/client`;

  const res = await axiosInstance.put(url, JSON.stringify(client))
  return res.data.Data;
}

export async function deleteClient(clientId) {
  let url = `${BASE_URL}/api/client/${clientId}`;

  const res = await axiosInstance.delete(url)
  return res.data.Data;
}
